import { normalizePhone } from '@zibanu/shared';

/**
 * Our WhatsApp chat as a link. WhatsApp's links want digits only, so the number
 * is tidied however it was typed; without a usable one, WhatsApp itself opens.
 */
export function whatsAppLink(number: string | undefined): string {
  return `https://wa.me/${(number && normalizePhone(number)) ?? ''}`;
}
